import { makeCygnusApiCall } from "../../../api/api";
import { SavedGridFilters, buildFilterParamName, safeJsonParse } from "./CygnusGrid.utils";

/** GET saved filters via personalization.get_params */
export async function fetchGridFilters(
  userId: string,
  gridKey: string
): Promise<SavedGridFilters | null> {
  const firm_id = localStorage.getItem("firmId");
  if (!firm_id) return null;

  const parameter_name = buildFilterParamName(gridKey, userId);

  const res = await makeCygnusApiCall({
    type: "POST",
    url: `/personalization/get_params/`,
    payload: { firm_id, parameter_name },
    show_message: false,
    customized_success_message: "",
    customized_failure_message: "Unable to fetch saved filters.",
    customized_error_message: "Error while fetching saved filters.",
    isblob: false,
    forMDM: false,
  });

  if (!res?.success) return null;

  const raw = res?.data?.[0]?.params?.[0]?.parameter_value_1 ?? null;
  return safeJsonParse<SavedGridFilters>(raw);
}

/** SET saved filters via personalization.set_params (flat payload) */
export async function saveGridFilters(payload: SavedGridFilters): Promise<boolean> {
  const firm_id = localStorage.getItem("firmId");
  if (!firm_id) return false;

  const parameter_name = buildFilterParamName(payload.gridKey, payload.userId);
  const parameter_value_1 = JSON.stringify(payload);

  const res = await makeCygnusApiCall({
    type: "POST",
    url: `/personalization/set_params/`,
    payload: { firm_id, parameter_name, parameter_value_1 },
    show_message: false,
    customized_success_message: "Filters saved.",
    customized_failure_message: "Unable to save filters.",
    customized_error_message: "Error while saving filters.",
    isblob: false,
    forMDM: false,
  });

  return !!res?.success;
}

/** CLEAR saved filters (set empty string) */
export async function clearGridFilters(userId: string, gridKey: string): Promise<boolean> {
  const firm_id = localStorage.getItem("firmId");
  if (!firm_id) return false;

  const parameter_name = buildFilterParamName(gridKey, userId);

  const res = await makeCygnusApiCall({
    type: "POST",
    url: `/personalization/set_params/`,
    payload: { firm_id, parameter_name, parameter_value_1: "" },
    show_message: false,
    customized_success_message: "Filters cleared.",
    customized_failure_message: "Unable to clear filters.",
    customized_error_message: "Error while clearing filters.",
    isblob: false,
    forMDM: false,
  });

  return !!res?.success;
}
